/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import _filter from "lodash/filter";

import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import { IconButton } from "@material-ui/core";

import StyledTextField from "./StyledTextField";

const filter = createFilterOptions({ ignoreCase: true });

const CarrierOrganizationAutoComplete = ({
  disabled,
  error,
  setSelectedOrganization,
  selectedOrganization,
  setIsCreate,
  searchIconPosition,
}) => {
  const organizations = useSelector((state) => {
    return state.organizations.organizations;
  });

  const handleSelection = (selection) => {
    setSelectedOrganization(selection);
  };

  const handleClear = () => {
    setSelectedOrganization({ id: "", name: "", label: "" });
  };

  const handleSetCreate = (isNewOrg) => {
    setIsCreate(isNewOrg);
  };

  const options = organizations.map((option) => ({
    id: option.organizationsId,
    name: `ADD TO '${option.name}'`,
    label: option.name,
  }));

  return (
    <>
      <Autocomplete
        fullWidth
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        freeSolo
        data-testid="carrier-org-autocomplete"
        handleHomeEndKeys
        disabled={disabled}
        getOptionLabel={(option) => `${option.label}`}
        getOptionSelected={(option, value) => option.id === value.id}
        options={options}
        value={selectedOrganization}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          // suggest creating a new organization
          if (
            params.inputValue !== "" &&
            _filter(filtered, (option) => {
              return (
                option.label.toLowerCase() === params.inputValue.toLowerCase()
              );
            }).length === 0
          ) {
            filtered.push({
              name: `CREATE '${params.inputValue}'`,
              label: params.inputValue,
            });
          }

          if (setIsCreate) {
            if (filtered.length === 1 && !filtered[0].id) {
              handleSetCreate(true);
            } else {
              handleSetCreate(false);
            }
          }

          return filtered;
        }}
        onChange={(event, obj) => handleSelection(obj)}
        renderOption={(option) => option.name}
        renderInput={(params) => {
          return (
            <StyledTextField
              {...params}
              label="Carrier organization"
              variant="outlined"
              error={error}
              helperText={error && "This is a required field."}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {selectedOrganization?.label && !disabled && (
                      <IconButton size="small" onClick={handleClear}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    )}
                    <SearchIcon
                      style={{ position: "absolute", left: searchIconPosition }}
                    />
                  </>
                ),
              }}
            />
          );
        }}
      />
    </>
  );
};

CarrierOrganizationAutoComplete.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  selectedOrganization: PropTypes.object,
  setSelectedOrganization: PropTypes.func.isRequired,
  setIsCreate: PropTypes.func,
  searchIconPosition: PropTypes.string.isRequired,
};
export default CarrierOrganizationAutoComplete;
